import React, { useRef } from 'react';
import '../css/company.css';
import '../css/companySl.css';
import '../css/companySt.css';
import '../css/companySm.css';
import SectionTitle from '../../../../component-module/component-services/title/section/ts/sectionTitle';
import HeroContent from '../../../../component-module/component-services/title/hero/ts/heroContent';
import ConicComSpotlight from './conicSpotlightCom';
import SectionTitleView from '../../../../component-module/component-services/title/section/ts/sectionTitleView';
import payImage from "../../../../assets-module/asset-configuration/image/pay-image.png"
import DynamicCard from '../../../../component-module/component-services/card/value/ts/dynamicCard';
import DynamicLine from './dynamicLine';
import ContactCard from '../../../../component-module/component-services/card/contact/ts/contactCard';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from '../../../../context-module/context-configuration/auth-provider/mediaProvider/mediaProvider';
import TalentList from '../../../../component-module/component-services/list/talents/ts/talent';
import { mapStepsWithApplyButton } from '../../career/ts/career.type';
import { useCmsPage } from '../../../../context-module/context-configuration/auth-provider/appShell/appShellContent/appUseCntData';
import { CompanyPageData } from './company.type';
import { API_ENDPOINTS } from '../../../../context-module/context-configuration/auth-provider/apiGroup/apiProvider';

const contactRouteMap: Record<number, string> = {
  1: '/contact/business-contact',
  2: '/contact/sales-contact',
  3: '/career',
};

export const mapContactCardsFromCMS = (
  lists?: any[],
  navigate?: (path: string) => void
) => {
  return lists?.map((item) => ({
    title: item?.title,
    paragraph: item?.paragraph,
    buttonText: item?.buttonText,
    onButtonClick: () => navigate?.(contactRouteMap[item.id]),
  }));
};

function Company() {
  const isMobile = useMediaQuery('(max-width: 850px)');
  const learnMore = useRef<HTMLDivElement | null>(null);
  const { data } = useCmsPage<CompanyPageData>(API_ENDPOINTS.ROUTE_URL.COMPANY);
  const navigate = useNavigate()
  const companyData = data?.company?.cta?.[0]
  const hero = companyData?.heroSection;
  const mission = companyData?.ourmissionSection?.content[0].headerSection;
  const ourvalue = companyData?.ourValueSection?.content[0].cardSection;
  const differentiator = companyData?.differentiatorSection?.content[0].cardSection;
  const joinUs = companyData?.joinusSection?.content[0].cardSection;
  const contact = companyData?.contactSection?.content[0].cardSection;
  const contactCards = mapContactCardsFromCMS(contact?.list, navigate);

  const rawSteps = joinUs?.list ?? [];

  const onClickApplyNow = () => {
    navigate("/career")
  }

  const stepsJob = mapStepsWithApplyButton(rawSteps, onClickApplyNow);

  const onClickLearnMore = () => {
    learnMore.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }

  return (
    <main className='scl--mai-com-bx-cont-st'>
      <section className="scl--web-page-company-hero-section">
        <div className='scl--wpchs-con-st'>
          {hero?.visible && (
            <HeroContent
              titleLine1={hero.headline}
              buttonText={hero?.primaryButton?.label}
              onButtonClick={onClickLearnMore}
              btnVisible={hero?.primaryButton?.visible}
            />
          )}
        </div>

        <div className="scl--web-page-company-gradient-overlay" >
          <ConicComSpotlight />
        </div>
      </section>

      {mission?.visible &&
        <>
          <section className="scl--web-page-company-our-value-section" ref={learnMore}>
            <div className='scl--wpcovs-cons-resp-str'>
              <div className='scl--wpcovs-se-con-str'>
                {mission?.visible && (
                  <SectionTitleView
                    span={mission.label}
                    title={mission.title}
                    paragraph={mission.description}
                  />
                )}
              </div>
            </div>
          </section>

          <div className="scl--web-page-company-our-value-content">
            {mission?.visible && mission?.image ?
              <img
                src={mission?.image}
                alt={mission?.label}
                onError={(e) => {
                  (e.currentTarget as HTMLImageElement).src = payImage;
                }}
              />
              :
              <img
                src={payImage}
                alt={"pay user"}
              />
            }
          </div>
        </>
      }

      {ourvalue?.visible &&
        <section className="scl--web-page-company-our-principle-section">
          <div className='scl--wpcops-bo-cont-str-compl'>
            {ourvalue?.visible && (
              <SectionTitle
                label={ourvalue.label}
                title={ourvalue.title}
                description={ourvalue.description}
                className='scl--wpcops-con-sec-str'
              />
            )}
            <div className='scl--wpcops-dc-art-con-str'>
              <div className='scl--wdacs-st-cont-bo-st'>
                {ourvalue?.visible &&
                  ourvalue?.list
                    ?.filter((item) => item?.visible)
                    .map((item) => (
                      <div
                        key={item.id}
                        className="scl--wdacs-bo-car-con-st"
                      >
                        <DynamicCard
                          iconSrc={item.iconSrc}
                          iconAlt={item.iconAlt}
                          title={item.title}
                          paragraph={item.description}
                          borderLeft={true}
                          borderRight={true}
                        />
                      </div>
                    ))}
              </div>
            </div>
          </div>
        </section>
      }

      {differentiator?.visible &&
        <section className="scl--web-page-differ-section">
          <div className='scl--wpds-resp-con-stl'>
            {differentiator?.visible && (
              <SectionTitle
                label={differentiator.label}
                title={differentiator.title}
                description={differentiator.description}
                className='scl--wpcops-con-sec-str'
              />
            )}

            <div className='scl--wpcops-dc-art-con-str'>
              <div className='scl--wdacs-st-cont-bo-st'>
                {differentiator?.visible &&
                  differentiator?.list
                    ?.filter((item) => item?.visible !== false)
                    .map((item) => (
                      <div
                        key={item.id}
                        className="scl--wdacs-bo-car-con-st"
                      >
                        <DynamicCard
                          iconSrc={item.iconSrc}
                          iconAlt={item.iconAlt}
                          title={item.title}
                          paragraph={item.description}
                          borderLeft={true}
                          borderRight={true}
                        />
                      </div>
                    ))}
              </div>
            </div>
          </div>
        </section>
      }

      {joinUs?.visible &&
        <section className='scl--wpchs-tal-con-str'>
          <div className='scl--wtcs-nea-fo-lin-dcl-st'>
            <div className='scl--wtcs-ti-con-st'>
              {joinUs?.visible && (
                <SectionTitleView
                  span={joinUs.label}
                  title={joinUs.title}
                  paragraph={joinUs.description}
                />
              )}
            </div>

            {!isMobile ? //NOSONAR
              <div className='scl--wtcs-stl-dcl-cont'>
                {joinUs?.visible && (
                  <DynamicLine dataStep={joinUs.list} />
                )}
              </div>
              :
              <div className='scl--step-comp-box-cont-stl'>
                <TalentList steps={stepsJob} />
              </div>
            }
          </div>
          <div className='scl--step-img-comp-bo-const-stl'>
            <img src={joinUs?.imageSrc} alt={joinUs?.label} />
          </div>
        </section>
      }

      {contact?.visible &&
        <section className="scl--web-page-ctac-section">
          <div className='scl--wpcs-cont-stl-bo'>
            {contact?.visible && (
              <SectionTitle
                label={contact?.label}
                title={contact?.title}
                description={contact?.description}
                className='scl--wpctacs-con-sec-str'
              />
            )}

            <div className='scl--wpctas-dc-art-con-str'>
              <div className='scl--wpctas-st-cont-bo-st'>
                {contact?.visible && contactCards?.map((card) => (
                  <div
                    key={card.title}
                    className="scl--wpctas-bo-car-con-st"
                  >
                    <ContactCard
                      key={card.title}
                      title={card.title ?? ''}
                      description={card.paragraph ?? ''}
                      buttonText={card.buttonText ?? ''}
                      onButtonClick={card.onButtonClick}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      }
    </main>
  );
}

export default Company;